// redux/actions/abogados/types.js
export const FETCH_OBJETOS_SUCCESS = "FETCH_OBJETOS_SUCCESS";
export const FETCH_OBJETOS_FAILURE = "FETCH_OBJETOS_FAILURE";
